'use strict';
const moment = require('moment');
const assert = require('assert');
const _ = require('lodash');

const calculateVerificationNumber = (paymentReference) => {
// For the paymentReference mod11 test we need to apply a weight to each number from RIGHT to left, hence the reversal of the weights
  const weights = [2, 4, 8, 5, 10, 9, 7, 3, 6, 1, 2, 4, 8, 5, 10].reverse();
  let sum = 0;

  for (let i = 0; i < 15; i++) {
    sum += weights[i] * paymentReference[i];
  }

  const verificationNumber = 11 - (sum % 11);

  // When 10, then 1. VerificationNumber is ALWAYS single digit.
  if (verificationNumber === 10) {
    return 1;
  }

  // When 11, then 0. VerificationNumber is ALWAYS single digit.
  if (verificationNumber === 11) {
    return 0;
  }

  return verificationNumber;
};

module.exports = (matchingNumber, sequenceNumber, includeVerificationNumber) => {
  assert(!_.isNil(matchingNumber), 'matchingNumber cannot be nil');
  assert(!_.isNil(sequenceNumber), 'sequenceNumber cannot be nil');
  const now = moment();
  const y = now.format('YYYY');
  const year = y.substring(y.length - 1);
  const month = now.format('MM');

  const paymentReference = ['03', matchingNumber, year, month, _.padStart(sequenceNumber, 6, '0')].join('');

  if (includeVerificationNumber) {
    const verificationNumber = calculateVerificationNumber(paymentReference);
    return `${verificationNumber}${paymentReference}`;
  }

  return paymentReference;
};
